import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarServiceHistory from "./component";
import withLogin from "../with-login";
import { openLoginPopup } from "../../au.configuration/actions";
import { createClassifiedLead } from "../checkout-info/actions";

const mapStateToProps = (
    {
        carDetails: {
            cmsConfig,
            config,
            content,
            leadAppointment
        },
        user: {
            phoneNumberVerified
        },
        dealer: {
            dealerInfo
        }
    }
) => ({
    cmsConfig,
    config,
    content,
    phoneNumberVerified,
    leadAppointment,
    dealerInfo
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    openLoginPopupConnect: openLoginPopup,
    createClassifiedLeadConnect: createClassifiedLead
}, dispatch);

export default withLogin(connect(mapStateToProps, mapDispatchToProps)(CarServiceHistory));
